const LETTER_LOGO_PNG = 'PNG'
const LETTER_LOGO_JPEG = 'JPEG'
const LETTER_LOGO_WEBP = 'WEBP'

export const letter = {
	LETTER_LOGO_PNG,
	LETTER_LOGO_JPEG,
	LETTER_LOGO_WEBP,
} as const
